import { render } from "./PendingOrders.vue?vue&type=template&id=218d8176&scoped=true&ts=true"
import script from "./PendingOrders.vue?vue&type=script&lang=ts"
export * from "./PendingOrders.vue?vue&type=script&lang=ts"

import "./PendingOrders.vue?vue&type=style&index=0&id=218d8176&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-218d8176"]])

export default __exports__